<template>
    <div class="row text-center">
        <h1>Success</h1>
    </div>
</template>

<script>
export default {
    name: 'StripeSuccess',
}
</script>